module.exports = __webpack_public_path__ + "img/cb6-r1.e0160ceb.gif";